import { PROBLEMS, IMAGES } from "@/data/content";
import { SectionHeading } from "./ui";
import { Reveal } from "./Reveal";

export default function ProblemSection() {
  return (
    <section id="problema" className="relative bg-brand-cream py-20 lg:py-32 grain-overlay">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <SectionHeading
            className="lg:col-span-7"
            eyebrow={PROBLEMS.eyebrow}
            title={PROBLEMS.title}
          />
          <Reveal delay={2} className="lg:col-span-5">
            <div className="relative overflow-hidden rounded-sm aspect-[4/3]">
              <img
                src={IMAGES.barrelCellar}
                alt="Barricaia di cantina contemporanea"
                loading="lazy"
                className="h-full w-full object-cover"
              />
            </div>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-brand-bordeaux/10 border border-brand-bordeaux/10 rounded-sm overflow-hidden">
          {PROBLEMS.cards.map((c, i) => (
            <Reveal key={c.k} delay={i % 3}>
              <div
                data-testid={`problem-card-${c.k}`}
                className="group h-full bg-brand-cream p-8 lg:p-10 transition-colors duration-300 hover:bg-brand-ivory"
              >
                <span className="font-mono text-xs text-brand-gold">{c.k}</span>
                <h3 className="mt-4 font-serif text-2xl text-brand-bordeaux">{c.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-brand-graphite/70">{c.body}</p>
                <div className="mt-6 h-px w-0 bg-brand-gold transition-all duration-500 group-hover:w-16" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
